module.exports = __webpack_public_path__ + "img/Inside-sp_4.0fcedfaa.jpg";